import { Button, Form, Modal } from 'shared/components/ui';
import React, { useState } from 'react';

import { Send, Email, Quiz } from '@mui/icons-material';
import api from '../../../../core/api/api';
import { useAuth } from '../../../../core/context/AuthContext';
import '../../../turnos/components/NotificarModal/NotificarModal.css';

const ACCIONES = [
  { id: 'reenviarInforme', label: 'Reenviar Informe', tipo: 'email', icon: <Email sx={{ fontSize: 18 }} />, color: '#3b82f6', descripcion: 'Envía el informe del estudio al email del paciente.' },
  { id: 'encuesta', label: 'Encuesta de Satisfacción', tipo: 'email', icon: <Quiz sx={{ fontSize: 18 }} />, color: '#8b5cf6', descripcion: 'Envía la encuesta de satisfacción por email al paciente.' },
];

const NotificarPracticaModal = ({ show, onHide, turno, onResult }) => {
  const { user } = useAuth();
  const [accion, setAccion] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const emailPaciente = turno?.persona?.mail || '';
  const telefonoPaciente = turno?.persona?.telCelular || '';
  const nombrePaciente = turno?.persona ? `${turno.persona.apellido}, ${turno.persona.nombre}` : '';

  const handleOpen = () => {
    setAccion('');
    setEmail(emailPaciente);
  };

  const handleEnviar = async () => {
    setLoading(true);
    try {
      if (accion === 'reenviarInforme') {
        const res = await api.get('/Email/SendEmail', {
          params: { idTurno: turno.idTurno, mail: email, usuario: user?.username || '' }
        });
        if (res.data === true) {
          onResult({ message: `Informe reenviado a ${email}`, type: 'success' });
        } else {
          onResult({ message: 'No se pudo reenviar el informe. Verificá que el turno tenga adjuntos.', type: 'error' });
        }
      } else if (accion === 'encuesta') {
        await api.get('/Email/EnviarEncuesta', { params: { idTurno: turno.idTurno, mail: email } });
        onResult({ message: 'Encuesta de satisfacción enviada al paciente', type: 'success' });
      }
      onHide();
    } catch (err) {
      const msg = err.response?.data || 'Error al enviar la notificación.';
      onResult({ message: typeof msg === 'string' ? msg : 'Error al enviar la notificación.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const isDisabled = () => {
    if (loading || !accion) return true;
    if (!email) return true;
    return false;
  };

  return (
    <Modal show={show} onHide={onHide} onEnter={handleOpen} centered size="lg" className="notificar-modal" dialogClassName="notificar-modal">
      <Modal.Header closeButton>
        <Modal.Title>Notificar - Turno #{turno?.idTurno}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="notificar-paciente-info">
          <strong>{nombrePaciente}</strong>
          {emailPaciente && <span className="notificar-dato">📧 {emailPaciente}</span>}
          {telefonoPaciente && <span className="notificar-dato">📱 {telefonoPaciente}</span>}
        </div>

        <div className="notificar-acciones">
          {ACCIONES.map(a => (
            <div
              key={a.id}
              className={`notificar-accion-item ${accion === a.id ? 'activa' : ''}`}
              onClick={() => setAccion(a.id)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && setAccion(a.id)}
              style={accion === a.id ? { borderColor: a.color, backgroundColor: `${a.color}10` } : {}}
            >
              <div className="notificar-accion-icon" style={accion === a.id ? { backgroundColor: `${a.color}20`, color: a.color } : {}}>
                {a.icon}
              </div>
              <div className="notificar-accion-content">
                <span className="notificar-accion-label">{a.label}</span>
                <span className="notificar-accion-desc">{a.descripcion}</span>
              </div>
              <span className="notificar-accion-badge" style={{ backgroundColor: `${a.color}15`, color: a.color }}>
                {a.tipo === 'whatsapp' ? 'WhatsApp' : 'Email'}
              </span>
            </div>
          ))}
        </div>

        {(accion === 'reenviarInforme' || accion === 'encuesta') && (
          <Form.Group className="mt-3">
            <Form.Label>Email destino</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email del paciente..."
            />
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>Cancelar</Button>
        <Button
          variant="success"
          onClick={handleEnviar}
          disabled={isDisabled()}
        >
          <Send sx={{ fontSize: 16, mr: 0.5 }} />
          {loading ? 'Enviando...' : 'Enviar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NotificarPracticaModal;
